import { render, staticRenderFns } from "./RegexTester.vue?vue&type=template&id=09b1b7d6&scoped=true"
import script from "./RegexTester.vue?vue&type=script&lang=js"
export * from "./RegexTester.vue?vue&type=script&lang=js"
import style0 from "./RegexTester.vue?vue&type=style&index=0&id=09b1b7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1b7d6",
  null
  
)

export default component.exports